<template>
	<section class="main">
		<header class="panel-heading">
			<h3 class="panel-title">扣銷點及輔導紀錄</h3>
		</header>
		<section class="panel panel-default" style="margin-bottom: 0px;" v-if="isAdmin('stay')">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">學期</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<!-- <option value="">--請選擇--</option> -->
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value">{{year.text}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4"></div>
							<div class="col-md-4"></div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-offset-4 col-md-4 ">
							<div class="col-md-offset-4 col-md-4">
								<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<div class="panel-collapse">
			<div class="panel-body">
				<div class="row">
					<div class="col-md-12 text-right form-inline" >
						<label>總點數: {{totalPoint}}</label>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<table class="table table-no-more table-bordered table-striped mb-none" >
							<thead>
								<tr>
									<th class="text-center" width="4%"></th>
									<th class="text-center" width="4%">學期</th>
									<th class="text-center" width="8%">學制</th>
									<th class="text-center" width="12%">系科年級</th>
									<th class="text-center" width="7%">學號</th>
									<th class="text-center" width="5%">姓名</th>
									<th class="text-center" width="10%">宿舍床位</th>
									<th class="text-center" width="8%">扣點概況</th>
									<th class="text-center" width="5%">(扣)點數</th>
									<th class="text-center" width="8%">違規日期</th>
                  <th class="text-center" width="8%">登記日期</th>
                  <th class="text-center" width="9%">{{(sessionData.accountType == 'STU'?"申請銷點":"銷扣點/輔導記錄")}}</th>
									<th class="text-center" width="8%">申請銷點日期</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in violateRecordGrid.rows" :key="index">
									<td data-title="" class="text-center">
										<a v-if="!item.violatePoint && item.crUser == sessionData.account" href="javascript:;" class="btn-link" @click="deleteViolate(item)">刪除</a>
									</td>
									<td data-title="學期" class="text-center">{{item.smtr}}</td>
									<td data-title="學制" class="text-center">{{item.deptSsymStr}}</td>
									<td data-title="系科年級" class="text-center">
										<span v-if="item.deptCode">{{item.deptCodeStr}}-{{item.drade}}年{{item.dradeClass}}班</span>
									</td>
									<td data-title="學號" class="text-center">{{item.account}}</td>
									<td data-title="姓名" class="text-center">{{item.name}}</td>
									<td data-title="宿舍床位" class="text-center">
										{{`${item.bedFloor}${item.bedRoom}-${item.bed}`}}
									</td>
									<td data-title="扣點概況" class="text-center">
										<a href="javascript:;" class="btn-link" @click="gotoView('stay.deduct.edit', {editType:'E',sno:item.sno, account:item.account, smtr:item.smtr, dormitoryType:item.dormitoryType})">
											{{item.violateName}}
										</a>
									</td>
									<td data-title="(扣)點數" class="text-center">
										<span v-if="!item.violatePoint">--</span>
										<span v-else>{{item.violatePoint}}</span>
									</td>
									<td data-title="違規日期" class="text-center">{{customFormatter(item.violateDate)}}</td>
                  <td data-title="登記日期" class="text-center">{{customFormatter(item.crDate)}}</td>
									<td :data-title="(sessionData.accountType == 'STU'?`申請銷點`:`銷扣點/輔導記錄`)" class="text-center">
										<a href="javascript:;" class="btn btn-success btn-block" v-if="sessionData.accountType != 'STU'" @click="violateRecord=item; showTutorPopupControl(true)">輔導記錄</a>
										<button class="btn btn-danger m-xs" v-if="sessionData.accountType == 'STU' && item.violatePoint < 0" @click="gotoView('stay.revoke.edit',{editType:'N',account:storeData.account, sno:item.sno})">申請銷點</button>
									</td>
									<td data-title="申請銷點日期" class="text-center">{{(item.revokeDate ? customFormatter(item.revokeDate) : "")}}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center" >
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
		<tutorPopup v-if="isShowPopup" :violateRecord="violateRecord"/>
	</section>
</template>
<script>
import tutorPopup from './tutorPopup.vue'
export default {
	components:{
		tutorPopup
	},
	data(){
		return {
			smtr:"",
			totalPoint:0,
			violateRecordGrid:{},
			page:1,
			pageSize:10,
			totalPage:0,
			isShowPopup:false,
			storeData:{},
			violateRecord:{},
		}
	},
	mounted(){
		if (this.getStore(this.$route.name)) {
			this.storeData = JSON.parse(this.getStore(this.$route.name));
			if(this.storeData.applyId){
				this.getStuTotalPoint();
			}
			this.gridInit();
		}
	},
	methods:{
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.gridInit();
		},
		gridInit(){
			let param = {
				page:this.page,
				pageSize:this.pageSize,
				model:{
					applyId:this.storeData.applyId,
					account:this.storeData.account,
					smtr:this.smtr,
				}
			};
			const api = "/api/Violate/violateRecordGrid";
			this.$axios.post(api, JSON.stringify(param)).then(resp =>{
				this.violateRecordGrid = resp.data.data;
				this.totalPage = this.violateRecordGrid.total
				this.page = this.violateRecordGrid.page;
				this.pageSize = this.violateRecordGrid.pageSize;
        this.totalPoint = this.totalPoint == 0 ? this.violateRecordGrid.rows.reduce((sum, a) => {
          const point = a.violatePoint || 0;
          return sum + point;
        }, 0) : this.totalPoint;
			});
		},
		getStuTotalPoint(){
			const api = `/api/Violate/violateRecordTotal/${this.storeData.applyId}`;
			this.$axios.post(api).then(resp =>{
				this.totalPoint = resp.data.data.totalPoint;
			});
		},
		selectYear(){
			let smtrArray = [];
			let nowYear = (new Date().getFullYear() - 1911);
			let nowMonth = new Date().getMonth() + 1;
			if(nowMonth < 8){
				nowYear = nowYear-1;
			}
			for(let y = nowYear; y > 100 ; y--){
				if((y == nowYear && nowMonth < 8) || y < nowYear){
					smtrArray.push({text:y+"年第二學期",value:y+"2"});
				}
				smtrArray.push({text:y+"年第一學期",value:y+"1"});
			}
			return smtrArray;
		},
		deleteViolate(item){
			let _this = this;
			bootbox.confirm("確定刪除此筆記錄?", function(result){
				if(result){
					const api = `/api/Violate/delViolateRecord/${item.sno}`;
					_this.$axios.delete(api).then(resp =>{
						bootbox.alert(resp.data.msg, function(){
							if(resp.data.status == "success"){
								_this.gridInit();
							}
						});
					});
				}
			});
		},
		showTutorPopupControl(isOpen){
			this.isShowPopup = isOpen;
		}
	},
	beforeRouteLeave(to, from, next) {
		if(!["stay.deduct.edit", "stay.revoke.edit"].includes(to.name)){
			this.removeStore(this.$route.name);
		}
		next();
	}
}
</script>
